import { useGetApproversQuery } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsConfigurationRpc.hooks';
import { APPROVAL_TYPE_TO_OBJECT_TYPE_ID } from 'ui-product-approvals-common/constants/approvalTypeIds';
import { useResolvedActors } from './useResolvedActors';
import { captureException } from '../utils/sentryUtils';
export const useApprovers = (approvalType, approvalAction) => {
  var _queryData$approvers;
  const {
    data: queryData,
    loading: queryLoading,
    error: queryError
  } = useGetApproversQuery({
    variables: {
      approvalTypeId: APPROVAL_TYPE_TO_OBJECT_TYPE_ID[approvalType],
      approvalAction
    },
    onError: error => {
      captureException(error, {
        extra: {
          fingerprint: 'useApprovers',
          approvalType,
          approvalAction
        }
      });
    }
  });
  const {
    approvers,
    isLoading: isResolving
  } = useResolvedActors((_queryData$approvers = queryData === null || queryData === void 0 ? void 0 : queryData.approvers) !== null && _queryData$approvers !== void 0 ? _queryData$approvers : []);
  return {
    approvers,
    isLoading: queryLoading || isResolving,
    isError: Boolean(queryError)
  };
};